module.exports = __webpack_public_path__ + "img/Milan_Jarosch_2025.7ef677ae.jpg";